var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { fullscreen: "" },
          model: {
            value: _vm.isDialogOpen,
            callback: function($$v) {
              _vm.isDialogOpen = $$v
            },
            expression: "isDialogOpen"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("Clasificación Patentes\n        ")]
                  ),
                  _c("v-spacer")
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.step,
                        callback: function($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { complete: _vm.step > 1, step: "1" } },
                            [
                              _vm._v(
                                _vm._s(_vm.labelStepper) + "\n            "
                              )
                            ]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { complete: _vm.step > 2, step: "2" } },
                            [_vm._v("Confirmar Datos\n            ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        [
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [
                              _c(
                                "v-card",
                                { staticClass: "mb-5" },
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "align-space-around": "",
                                            "justify-center": "",
                                            column: "",
                                            "fill-height": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm6: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Id Dispositivo",
                                                  disabled: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataGrid.id_dispositivo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dataGrid,
                                                      "id_dispositivo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataGrid.id_dispositivo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm6: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Número Serie"
                                                },
                                                model: {
                                                  value: _vm.nro_serie,
                                                  callback: function($$v) {
                                                    _vm.nro_serie = $$v
                                                  },
                                                  expression: "nro_serie"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm6: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Sufijo Patente"
                                                },
                                                model: {
                                                  value: _vm.suf_patente,
                                                  callback: function($$v) {
                                                    _vm.suf_patente = $$v
                                                  },
                                                  expression: "suf_patente"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm6: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Rótulo" },
                                                model: {
                                                  value: _vm.rotulo,
                                                  callback: function($$v) {
                                                    _vm.rotulo = $$v
                                                  },
                                                  expression: "rotulo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          !_vm.isConfiguration
                                            ? _c(
                                                "div",
                                                [
                                                  _vm.showPatentesAsignadas
                                                    ? _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm6: "",
                                                            md12: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "h4",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "normal"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Patentes asignadas actualmente:\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.showPatentesAsignadas
                                                    ? _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm6: "",
                                                            md12: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              items:
                                                                _vm.patentes_existentes,
                                                              attach: "",
                                                              chips: "",
                                                              label: "Patentes",
                                                              multiple: "",
                                                              "item-text":
                                                                "nombre",
                                                              "item-value": "id"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.patentes_existentes_selected,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.patentes_existentes_selected = $$v
                                                              },
                                                              expression:
                                                                "patentes_existentes_selected"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c("br"),
                                                  _c("br"),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm6: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "normal"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Nueva Clasificación\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm6: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          attrs: { row: "" },
                                                          model: {
                                                            value:
                                                              _vm.tipoAsignacion,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.tipoAsignacion = $$v
                                                            },
                                                            expression:
                                                              "tipoAsignacion"
                                                          }
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Cliente",
                                                              value: "cliente"
                                                            }
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "Flota/Patente",
                                                              value: "flota"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm.tipoAsignacion ==
                                                  "cliente"
                                                    ? _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm6: "",
                                                            md12: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              items:
                                                                _vm.allClientes,
                                                              label: "Cliente",
                                                              "item-text":
                                                                "nombre",
                                                              "item-value": "id"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.cliente,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.cliente = $$v
                                                              },
                                                              expression:
                                                                "cliente"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.tipoAsignacion == "flota"
                                                    ? _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm6: "",
                                                            md12: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              items:
                                                                _vm.allFlota,
                                                              label: "Flota",
                                                              "item-text":
                                                                "nombre",
                                                              "item-value": "id"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.watchFlota
                                                            },
                                                            model: {
                                                              value: _vm.flota,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.flota = $$v
                                                              },
                                                              expression:
                                                                "flota"
                                                            }
                                                          }),
                                                          _c(
                                                            "h5",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    !_vm.flota &&
                                                                    _vm.tipoAsignacion ==
                                                                      "flota",
                                                                  expression:
                                                                    "!flota && tipoAsignacion == 'flota'"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                color: "red"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                '\n                          Si no encuentra la flota dentro del listado. Debe ir\n                          a asignar la flota a un cliente en "'
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      "/Flota-Vehiculo"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Configuración Flota Vehiculo"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                '"\n                        '
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.flota &&
                                                  _vm.itemsCodVehiculo.length >
                                                    0 &&
                                                  _vm.tipoAsignacion == "flota"
                                                    ? _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm6: "",
                                                            md12: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              items:
                                                                _vm.itemsCodVehiculo,
                                                              label: "Patente",
                                                              "item-text":
                                                                "patente_vehiculo",
                                                              "item-value":
                                                                "id",
                                                              "return-object":
                                                                ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.codVehiculoSelected,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.codVehiculoSelected = $$v
                                                              },
                                                              expression:
                                                                "codVehiculoSelected"
                                                            }
                                                          }),
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticStyle: {
                                                                color: "red"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                '\n                          Si no encuentra la pantente y la camara no tendrá\n                          GPS. Debe crear el vehículo en "'
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      "/Clasificacion-Patentes-Camaras"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Configuración Plataforma/Vehiculo"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                '"\n                        '
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.close()
                                    }
                                  }
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.initStepDos()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Continuar\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        "align-center": "",
                                        "justify-center": "",
                                        row: "",
                                        "fill-height": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "mb-5",
                                              attrs: { height: "300px" }
                                            },
                                            [
                                              _c(
                                                "v-container",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": "",
                                                        "justify-center": "",
                                                        column: "",
                                                        "fill-height": ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-input", [
                                                        _c("h3", [
                                                          _vm._v("Id Camara:")
                                                        ]),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "padding-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.idCamara
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _c("v-input", [
                                                        _c("h3", [
                                                          _vm._v("Nro Serie:")
                                                        ]),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "padding-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.nro_serie
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _c("v-input", [
                                                        _c("h3", [
                                                          _vm._v(
                                                            "Sufijo Patente:"
                                                          )
                                                        ]),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "padding-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.suf_patente
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _c("v-input", [
                                                        _c("h3", [
                                                          _vm._v("Rótulo:")
                                                        ]),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "padding-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(_vm.rotulo)
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _c("v-input", [
                                                        _c("h3", [
                                                          _vm._v("Marca:")
                                                        ]),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "padding-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.dataGrid
                                                                  .marca
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm.tipoAsignacion ==
                                                      "cliente"
                                                        ? _c("v-input", [
                                                            _c("h3", [
                                                              _vm._v("Cliente:")
                                                            ]),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.nombreClienteSeleccionado
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm.tipoAsignacion ==
                                                      "flota"
                                                        ? _c("v-input", [
                                                            _c("h3", [
                                                              _vm._v("Flota:")
                                                            ]),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.nombreFlotaSeleccionada
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm.tipoAsignacion ==
                                                      "flota"
                                                        ? _c("v-input", [
                                                            _c("h3", [
                                                              _vm._v(
                                                                "Vehiculo:"
                                                              )
                                                            ]),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .codVehiculoSelected
                                                                      .patente_vehiculo
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm.showPatentesAsignadas
                                                        ? _c("v-input", [
                                                            _c("h3", [
                                                              _vm._v(
                                                                "Asignación Actual:"
                                                              )
                                                            ]),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.descPatentesExistentes
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 1
                                    }
                                  }
                                },
                                [_vm._v("Volver")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveData()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Guardar\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-card-actions", [_c("v-spacer")], 1)
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }